module.exports = __webpack_public_path__ + "media/images/front/company/postal_2-900131fed95ca84bb044c6e3f1810310.png";